import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import Dialog from 'react-bootstrap-dialog'
import {assigneAgentStoreTicketsUpdateReady} from '../redux/stores'
import apiService from '../services/apiservices'
import { headerDataUpdate, subHeaderDataUpdate,buildNumberUpdate } from '../../../redux/user'
import * as Constants from '../../../common/constants'
//import * as Helpers from '../../../common/helpers'
//import  {ValidateEmail ,ValidatePhone,isLatitude,isLongitude} from '../../../common/ValidationFunctions/CommonValidation'
import {PEAgentsComboList} from './DropDowns/index'

//import DateTimeField from "react-bootstrap-datetimepicker";




function filterUnwantedData(storesTicketsData) {
    // let data = {}
    // if (storesTicketsData && storesTicketsData.data && storesTicketsData.data) {
    //     data = storesTicketsData.data
    // }

    let newData = {}
            newData.id = storesTicketsData.id ? storesTicketsData.id : ""
            newData.store_name =  storesTicketsData.store.name ? storesTicketsData.store.name : "NA"
            newData.store_id =  storesTicketsData.store_id ? storesTicketsData.store_id : "NA"
            newData.platform_name =storesTicketsData.platform_name ? storesTicketsData.platform_name : "NA"
            newData.type =storesTicketsData.type ? storesTicketsData.type : "NA"
            newData.status =storesTicketsData.status ? storesTicketsData.status : "NA"


    return newData
}

class AssignAgentStoresTicket extends Component {

    constructor() {
        super()
        this.state = {
            
            bodyHeight: "0px",

          

            agentId: null,


            storesTicketSelectedId:"",
            storesTicketsData:{},
           

            agentIdErrorText: false,
            agentIdErrorData: '',            

            subTitle:Constants.ASSIGN_AGENT_STORE_TICKET
            
        }
        this.isComponentStillMounted = true

        this.agentIdComponent = null
        this.agentIdSection = null
    }

    componentWillMount() {
        this.isComponentStillMounted = true
        
        if(this.props.stores && this.props.stores.storesTicketSelectedId && this.props.stores.storesTicketSelectedId !== null){
            this.props.dispatch(headerDataUpdate(Constants.ASSIGN_AGENT_STORE_TICKET))
            this.setState({subTitle: Constants.ASSIGN_AGENT_STORE_TICKET})
            this.props.dispatch(subHeaderDataUpdate())
            this.setState({
                storesTicketSelectedId:this.props.stores.storesTicketSelectedId
            });

        }else{
            this.props.history.goBack();
        }
        
        window.addEventListener("resize", this.updateDimensions)
        this.updateDimensions()

        this.getStoreTicketData();
    }



    componentDidMount() {

    }

    getStoreTicketData = () =>{

        this.agentIdSection = ReactDOM.findDOMNode(this.refs.agentIdSection)
        
        
        this.props.dispatch(assigneAgentStoreTicketsUpdateReady(false))
        if(this.props.stores && this.props.stores.storesTicketSelectedId && this.props.stores.storesTicketSelectedId !== null){
            apiService.getStoresTicketDetails(this.props.stores.storesTicketSelectedId)
                .then(responseData => {
                    
                    if (this.isComponentStillMounted && responseData.status === "SUCCESS") {

                        let storesTicketsData=filterUnwantedData(responseData.data)                      

                        this.setState({
                            storesTicketsData:storesTicketsData,                            
                        })

                        this.props.dispatch(assigneAgentStoreTicketsUpdateReady(true))
                    }
                })
                .catch(err => {
                    console.log("Error data: ", err)
                    this.props.dispatch(assigneAgentStoreTicketsUpdateReady(true))
                    this.dialog.show({
                        title: "Server respond with Error data",
                        body: 'Fetching stores tickets got interrupted',
                        actions: [
                            Dialog.OKAction(() => {
                                this.props.history.goBack()
                            })
                        ],
                        onHide: (dialog) => {
                            dialog.hide()
                            this.props.history.goBack()
                        }
                    })
                })
        }

    }

    updateDimensions = () => {
        if (window.innerWidth <= 767) {
            this.setState({
                bodyHeight: (window.innerHeight - 130) + "px",
            })
        } else {
            this.setState({
                bodyHeight: (window.innerHeight - 100) + "px",
            })
        }
    }

    validateBuildNumber = (data) => {
        if (this.props.user && this.props.user.build_number && data && data.app_build_no) {
            if (this.props.user.build_number === data.app_build_no) {
                //do smthng here
            } else {
               this.props.dispatch(buildNumberUpdate(data.app_build_no))
window.location.reload()
            }
        } else {
            this.props.dispatch(buildNumberUpdate(data.app_build_no))
window.location.reload()
        }
    }

    componentWillUnmount() {
        this.isComponentStillMounted = false
        window.removeEventListener("resize", this.updateDimensions)
    }

   

    mandateValidation =(inputName,type)=>{
        let inputComponent =inputName+"Component"
        let inputErrorText =inputName+"ErrorText"
        let inputErrorData =inputName+"ErrorData"
        let inputSection =inputName+"Section"
        let errorMsg = Constants.NON_VALID_MSG_INPUT
        if(Constants.FORM_SELECT ===type){
            errorMsg= Constants.NON_VALID_MSG_SELECT
            console.log("input name :::",inputName)
            console.log("input data :::",this.state[inputName])
        }
        if(this.state[inputName] === null || this.state[inputName] === undefined || this.state[inputName] === ""){
            this[inputComponent].focus()
            this.setState({[inputErrorText]:true,[inputErrorData]:errorMsg})
            this[inputSection].className= this[inputSection].className.replace(" has-error", "")
            this[inputSection].className += " has-error"
            return { status: false, value: '' }
        }
        return { status: true }
    }

    onSaveClick = () => {
        let data ={}

        this.props.dispatch(assigneAgentStoreTicketsUpdateReady(false))
        
        let agentIdObject = this.mandateValidation("agentId",Constants.FORM_SELECT)
        if (agentIdObject.status) {
            data.assigned_agent_id = this.state.agentId
        } else {
                this.props.dispatch(assigneAgentStoreTicketsUpdateReady(true))
                this.dialog.show({
                            title: "Error!!",
                            body: "Please select agent to assign this ticket.",
                            actions: [
                                Dialog.OKAction(() => {
                                })
                            ],
                        })
            return
        }

        let checkedValue = document.getElementById("checkbox_id").checked;


        data.store_id=this.state.storesTicketsData.store_id
        if(checkedValue){
            data.assigned_allstore_kitchen=1
        }else{
            data.assigned_allstore_kitchen=0 
        }
        

        let apiPayloadData=data
    
         apiService.assignAgentStoreTicket(apiPayloadData,this.state.storesTicketsData.id)
            .then(responseData => {
                 
                    if (responseData.status === "SUCCESS") {
                        this.props.dispatch(assigneAgentStoreTicketsUpdateReady(true))
                        this.props.history.push("/dashboard/storestickets/list")
                    } else {

                        this.props.dispatch(assigneAgentStoreTicketsUpdateReady(true))
                        this.dialog.show({
                            title: "Alert",
                            body: responseData.reason ? responseData.reason : "",
                            actions: [
                                Dialog.OKAction(() => {
                                })
                            ],
                        })
                    }
                
            })
            .catch(err => {
                this.props.dispatch(assigneAgentStoreTicketsUpdateReady(true))
                console.error("Error data: ", err)
               alert("exception"+ err);
            })
        
      
        
    }


   agentChange = (data) => {
    this.agentIdComponent.value=data.value
        this.setState({
            agentId :data.value,
            agentIdErrorText: false,
            agentIdErrorData: ''
        })
        this.agentIdSection.className= this.agentIdSection.className.replace(" has-error", "")
    }


    integerValidation = (value) => {
        if (/\D/.test(value)) {
            return true
        } else {
            return false
        }
    }

    onCancelClick = () => {
        this.props.history.goBack()
    }
    
    render() {
        return (
            <div className="line-item-edit">

             <div className="col-md-12" style={{ "paddingBottom" : "1%"}}>
                    <a href="" 
                        onClick={(e) => {e.preventDefault() 
                                    this.props.history.goBack()}}> 
                            <i class="fa fa-arrow-left" aria-hidden="true"></i> Go Back
                    </a>
                </div>
                <Dialog ref={el => this.dialog = el} />
                <section className="content">
                    <div className="row">
                        <div className="col-md-12 col-sm-12 col-xs-12" style={{ height: this.state.bodyHeight }}>
                            <div className="box box-info" style={{ borderTop: "0px" }}>
                                <div className="box-header with-border">
                                    <h3 className="box-title" style={{ fontWeight: 600 }}>Assign Agent</h3>
                                </div>
                                {(() => {
                           if(this.state.storesTicketsData.store_name && this.state.storesTicketsData.store_name!=="" && this.state.storesTicketsData.store_name!==undefined){
                           return(

                                <div className="form-horizontal">
                                    <div className="box-body" style={{ marginTop: "20px", marginBottom: "20px" }}>


                                        <div className="col-md-12 col-sm-12 col-xs-12">
                                            <div className="col-md-6 col-sm-12 col-xs-12">
                                                <div className="form-group">
                                                    <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Store :</label>
                                                    <div className="col-sm-9">
                                                            {this.state.storesTicketsData.store_name}
                                                        
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-6 col-sm-12 col-xs-12">
                                                <div className="form-group">
                                                    <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Platform :</label>
                                                    <div className="col-sm-9">
                                                            {this.state.storesTicketsData.platform_name}
                                                        
                                                    </div>
                                                </div>
                                            </div>
                                        </div>


                                        <div className="col-md-12 col-sm-12 col-xs-12">
                                            <div className="col-md-6 col-sm-12 col-xs-12">
                                                <div className="form-group">
                                                    <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Type :</label>
                                                    <div className="col-sm-9">
                                                            {this.state.storesTicketsData.type}
                                                        
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-6 col-sm-12 col-xs-12">
                                                <div className="form-group">
                                                    <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Status :</label>
                                                    <div className="col-sm-9">
                                                            {this.state.storesTicketsData.status}
                                                        
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <br/>


                                     <div className="col-md-12 col-sm-12 col-xs-12">

                                         <div className="col-md-6 col-sm-12 col-xs-12">
                                                <div className="form-group" ref={el => this.agentIdSection = el}>
                                                    <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Select Agent :</label>
                                                    <div className="col-sm-9" ref={el => this.agentIdComponent = el}>
                                                       
                                                    <PEAgentsComboList agentChange={this.agentChange} selectedValue={this.state.agentId} />

                                                        <span className="help-block"style={{display: this.state.agentIdErrorText ? 'block' : 'none',marginTop: '0px', marginBottom: '0px' }}>
                                                            {this.state.agentIdErrorData}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                            </div>

                                             <div className="col-md-12 col-sm-12 col-xs-12">
                                                <div className="col-md-8 col-sm-12 col-xs-12">
                                                   <div className="form-group" style={{"marginLeft":"20%"}}>
                                                      <input className="checkbox" type="checkbox" name="checkbox" id="checkbox_id" value="value" style={{"float": "left"}}/>
                                                      <label for="checkbox_id" style={{"float": "left","margin": "4px 6px"}}>Please (&#10004;) this checkbox to assign all existing tickets from this kitchen to this agent.</label>
                                                   </div>
                                                </div>
                                             </div>

                                              <div className="col-md-12 col-sm-12 col-xs-12">

                                              <div className="col-md-6 col-md-offset-1 col-sm-12 col-xs-12">
                                                    <span><b>Note:</b>&nbsp;&nbsp;&nbsp;Please <a href="/dashboard/storestickets/agents/list">click here</a> to assign future tickets from this kitchen to particular agent.</span>
                                                
                                                 </div>
                                                 </div>
                        
                                    </div>

                                    <div className="box-footer">
                                        <button
                                            className="btn btn-default"
                                            onClick={(e) => {
                                                e.preventDefault()
                                                this.onCancelClick()
                                            }}>
                                            Cancel
                                        </button>
                                        <button
                                            className="btn btn-info pull-right"
                                            onClick={(e) => {
                                                e.preventDefault()
                                                this.onSaveClick()
                                            }}>
                                            Assign Ticket
                                        </button>
                                    </div>
                                </div>
                                )
                                }
                           })()}  


                            </div>
                        </div>
                    </div>
                </section>
            </div>
        )
    }

    keyedInputChange = (keyedName) => {
        console.log(keyedName)
        let keyedComponent =keyedName+"Component"
        let keyedErrorText =keyedName+"ErrorText"
        let keyedErrorData =keyedName+"ErrorData"
        let keyedSection =keyedName+"Section"
        let name=this[keyedComponent].value.trim()
        this.setState({[keyedName]:name})
        if(!name){
            this.setState({[keyedName] : null})
            return
        }
        this.setState({ [keyedErrorText]: false, [keyedErrorData]: '' })
        this[keyedSection].className = this[keyedSection].className.replace(" has-error", "")
    }

}
function mapStateToProps(state) {
    return {
        stores: state.stores,
        user: state.user,
    }
}

export default connect(mapStateToProps)(withRouter(AssignAgentStoresTicket))


// WEBPACK FOOTER //
// ./src/modules/Stores/Components/AssignAgentStoresTicket.js